/* DateTimePickerPopupComponent.js */

"use strict";
const Renderer = require("./DateTimePickerPopupRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class DateTimePickerPopupComponent extends BaseScheduleComponent {
    constructor(schedule, schedulePropName) {
        super(Renderer, schedule, schedulePropName);
    }
}
module.exports = DateTimePickerPopupComponent;
